import { Check } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { SectionHeading } from "@/components/ui/section-heading";

const strengthsEn = [
  "Fast mobilization",
  "Flexible manpower solutions",
  "Project-focused support",
  "Commitment to safety",
];

const strengthsAr = [
  "تعبئة سريعة",
  "حلول عمالة مرنة",
  "دعم يركز على المشروع",
  "الالتزام بالسلامة",
];

const OurStrength = () => {
  const { language } = useLanguage();
  const isAr = language === 'ar';
  const strengths = isAr ? strengthsAr : strengthsEn;
  const eyebrow = isAr ? "بناء الثقة" : "Trust builder";
  const h1 = isAr ? "نقاط" : "Our";
  const h2 = isAr ? "قوّتنا" : "Strength";
  const p = isAr
    ? "من فرق العمل الماهرة إلى المعدات الموثوقة، كل جزء من عملياتنا مصمم لإبقاء مشروعك يسير — بأمان وفي الوقت المحدد وضمن الميزانية."
    : "From skilled crews to dependable equipment, every part of our operation is built to keep your project moving — safely, on time, and on budget.";
  return (
    <section id="strength" className="py-20 bg-muted/40">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <SectionHeading
              eyebrow={eyebrow}
              accent={h2}
              wrapperClassName="mb-6"
            >
              {h1}
            </SectionHeading>
            <p className="text-lg text-muted-foreground leading-relaxed mb-6">
              {p}
            </p>
          </div>
          <ul className="grid sm:grid-cols-2 gap-4">
            {strengths.map((s) => (
              <li
                key={s}
                className="flex items-center gap-4 bg-card border border-border rounded-xl p-5 hover:border-accent hover:shadow-soft transition-smooth"
              >
                <span className="w-10 h-10 rounded-full bg-accent flex items-center justify-center flex-shrink-0">
                  <Check className="w-5 h-5 text-primary-darker" strokeWidth={3} />
                </span>
                <span className="font-semibold text-primary-darker">{s}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default OurStrength;